import React, { useDeferredValue, useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import HeaderTab from "../../Components/headerTab/HeaderTab";
import { SearchOutlined } from "@ant-design/icons";
import { Button, Spin, Table, Tabs, Typography, message } from "antd";
import { ExcludedAPI } from "../../API/ExcludedApi";
import {
    getCompletedColumns,
    REJECTED_COLUMNS_HEAD,
    STYLES,
} from "./ExcludedUtils";
import TableEmptyContent from "../../Components/TableEmptyContent/TableEmptyContent";
import { useFlightModel } from "../../contexts/FlightModelContext";
import ClosedLoopFeedbackModal from "./ClosedLoopFeedbackModal";

export default function ExcludedTab() {
    const [messageApi, contextHolder] = message.useMessage();
    const [spinning, setSpinning] = useState(false);
    const [defualtReject, setDefualtReject] = useState([]);
    const [defualtComplete, setDefualtComplete] = useState([]);
    const [rejectedSelectedRowsArray, setRejectedSelectedRowsArray] = useState(
        [],
    );
    const [rMoveList, setRMoveList] = useState([]);
    const [completedSelectedRowsArray, setCompletedSelectedRowsArray] = useState(
        [],
    );
    const [cMoveList, setCMoveList] = useState([]);
    const [completedList, setCompletedList] = useState([]);
    const [rejectedList, setRejectedList] = useState([]);
    const [rejectIput, setRejectInput] = useState("");
    const [completeIput, setCompleteIput] = useState("");
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
    const [selectedCompletedRecord, setSelectedCompletedRecord] = useState(null);
    const { selectedFlightModel, refreshFlightModels } = useFlightModel();

    const deferredreject = useDeferredValue(rejectIput);
    useEffect(() => {
        rejectSerachFun();
    }, [deferredreject]);

    const deferrecomplete = useDeferredValue(completeIput);
    useEffect(() => {
        completeSerachFun();
    }, [deferrecomplete]);

//  async function getAllList() {
//         let flightModelToUse = selectedFlightModel;

//         // fallback from context
//         if (!flightModelToUse) {
//             const refreshed = await refreshFlightModels();
//             flightModelToUse = refreshed?.selectedFlightModel || null;
//         }

//         if (!flightModelToUse) {
//             messageToast("error", "No flight model selected."); setSpinning(false);
//             return;
//         }
//         const queryParams = {
//             params: {
//                 flight_model: flightModelToUse
//                 // localStorage.getItem("flight_model"),
//             },
//         };
//         setSpinning(true);
//         await ExcludedAPI.rejectedCompletedList(queryParams)
//             .then((res) => {
//                 if (res.data?.status === true) {
//                     const rarr = res.data?.rejected.map((ele, ind) => ({
//                         ...ele,
//                         key: ind + 1,
//                     }));
//                     const carr = res.data?.completed.map((ele, ind) => ({
//                         ...ele,
//                         key: ind + 1,
//                     }));
//                     setCompletedList(carr);
//                     setRejectedList(rarr);
//                     setDefualtReject(rarr);
//                     setDefualtComplete(carr);
//                 } else {
//                     messageToast("error", res.data.message);
//                 }
//             })
//             .catch((err) => {
//                 messageToast("error", "Internal Server Error");
//             })
//             .finally(() => {
//                 setSpinning(false);
//             });
//     }
    async function getAllList() {
        let flightModelToUse = selectedFlightModel;
        if (!flightModelToUse) {
            const refreshed = await refreshFlightModels();
            flightModelToUse = refreshed?.selectedFlightModel || null;
        }

        if (!flightModelToUse) {
            messageToast("error", "No flight model selected."); setSpinning(false);
            return;
        }
        setSpinning(true);
        await Promise.all([
            ExcludedAPI.rejectedCompletedListNew(flightModelToUse),
            ExcludedAPI.escalationCompletedList(flightModelToUse, { page: 1, page_size: 5000, search: "" }),
        ])
            .then(([rejectedRes, completedRes]) => {
                if (rejectedRes?.data?.status !== true) {
                    messageToast("error", rejectedRes?.data?.message || "Failed to fetch rejected items.");
                    return;
                }

                if (completedRes?.data?.status !== true) {
                    messageToast("error", completedRes?.data?.message || "Failed to fetch escalation completed items.");
                    return;
                }

                const rejectedData = Array.isArray(rejectedRes?.data?.rejected)
                    ? rejectedRes.data.rejected
                    : Array.isArray(rejectedRes?.data?.data)
                        ? rejectedRes.data.data
                        : [];

                const completedData = Array.isArray(completedRes?.data?.data)
                    ? completedRes.data.data
                    : Array.isArray(completedRes?.data?.completed)
                        ? completedRes.data.completed
                        : [];

                const rarr = rejectedData.map((ele, ind) => ({
                    ...ele,
                    key: ind + 1,
                }));
                const carr = completedData.map((ele, ind) => ({
                    ...ele,
                    key: ind + 1,
                }));

                setCompletedList(carr);
                setRejectedList(rarr);
                setDefualtReject(rarr);
                setDefualtComplete(carr);
            })
            .catch(() => {
                messageToast("error", "Internal Server Error");
            })
            .finally(() => {
                setSpinning(false);
            });
    }

    const messageToast = (type, message) => {
        messageApi.open({
            type: type,
            content: message,
            duration: 6,
        });
    };

    useEffect(() => {
        getAllList();
    }, []);

    const removeRejectsFun = async () => {
        if (rMoveList.length > 0) {
            let flightModelToUse = selectedFlightModel;

            // fallback from context
            if (!flightModelToUse) {
                const refreshed = await refreshFlightModels();
                flightModelToUse = refreshed?.selectedFlightModel || null;
            }

            if (!flightModelToUse) {
                messageToast("error", "No flight model selected."); setSpinning(false);
                return;
            }
            const bodydata = {
                flight_model: flightModelToUse,
                //  localStorage.getItem("flight_model"),
                rejected: rMoveList,
                completed: [],
            };
            removeSpecs(bodydata);
            setRejectedSelectedRowsArray([]);
            setRMoveList({});
        } else {
            messageToast("warning", "Please Select Any one of the spec");
        }
    };
    const removeCompletedFun = async () => {
        if (cMoveList.length > 0) {
            let flightModelToUse = selectedFlightModel;

            // fallback from context
            if (!flightModelToUse) {
                const refreshed = await refreshFlightModels();
                flightModelToUse = refreshed?.selectedFlightModel || null;
            }

            if (!flightModelToUse) {
                messageToast("error", "No flight model selected."); setSpinning(false);
                return;
            }
            const bodydata = {
                flight_model: flightModelToUse,
                //  localStorage.getItem("flight_model"),
                rejected: [],
                completed: cMoveList,
            };
            removeSpecs(bodydata);
            setCompletedSelectedRowsArray([]);
            setCMoveList({});
        } else {
            messageToast("warning", "Please Select Any one of the spec");
        }
    };

    async function removeSpecs(bodydata) {
        setSpinning(true);
        await ExcludedAPI.removeInList(bodydata)
            .then((res) => {
                if (res.data?.status === true) {
                    getAllList();
                } else {
                    messageToast("error", res.data.message);
                    setSpinning(false);
                    if (res.data?.reload === true) {
                        setTimeout(() => {
                            window.location.reload();
                        }, "2000");
                    }
                }
            })
            .catch((err) => {
                messageToast("error", "Internal Server Error");
                setSpinning(false);
            });
    }

    function rejectSerachFun() {
        setRejectedSelectedRowsArray([]);
        setRMoveList([]);
        if (rejectIput.trim() !== "") {
            let arr = [...defualtReject];
            let filterArr = arr.filter((ele) => {
                if (
                    rejectIput.trim() !== "" &&
                    ele.spec_concat
                        .toLowerCase()
                        .includes(rejectIput.trim().toLowerCase())
                ) {
                    return true;
                }
                return false;
            });
            setRejectedList(filterArr);
        } else {
            setRejectedList([...defualtReject]);
        }
    }

    function completeSerachFun() {
        setCompletedSelectedRowsArray([]);
        setCMoveList([]);
        if (completeIput.trim() !== "") {
            let arr = [...defualtComplete];
            let filterArr = arr.filter((ele) => {
                if (
                    completeIput.trim() !== "" &&
                    ele.spec_concat
                        .toLowerCase()
                        .includes(completeIput.trim().toLowerCase())
                ) {
                    return true;
                }
                return false;
            });
            setCompletedList(filterArr);
        } else {
            setCompletedList([...defualtComplete]);
        }
    }

    const handleCompletedView = async (record) => {
        if (!record) return;

        try {
            setSpinning(true);

            let flightModelToUse = selectedFlightModel;
            if (!flightModelToUse) {
                const refreshed = await refreshFlightModels();
                flightModelToUse = refreshed?.selectedFlightModel || null;
            }

            if (!flightModelToUse) {
                messageToast("error", "No flight model selected.");
                return;
            }

            const escalationId = record?.escalation_id || record?.id;
            if (!escalationId) {
                messageToast("error", "Escalation id is missing.");
                return;
            }

            const response = await ExcludedAPI.getClosedLoopFeedback(escalationId, {
                params: {
                    flight_model: flightModelToUse,
                },
            });

            const uploads = Array.isArray(response?.data?.available_uploads)
                ? response.data.available_uploads
                : [];

            if (uploads.length === 0) {
                messageToast("warning", "No data for comparison");
                return;
            }

            setSelectedCompletedRecord(record);
            setIsFeedbackModalOpen(true);
        } catch (error) {
            messageToast("error", "Internal Server Error");
        } finally {
            setSpinning(false);
        }
    };

    const handleClosedLoopRemoved = async () => {
        setIsFeedbackModalOpen(false);
        setSelectedCompletedRecord(null);
        await getAllList();
    };

    return (
        <div className="container_div">
            <Helmet>
                <title>SpecOptimzer | Excluded</title>
            </Helmet>

            <Spin spinning={spinning}>
                <HeaderTab currrentTab="excludedTab" />

                <div className="box_wraper_div">
                    <Tabs
                        defaultActiveKey="rejected"
                        items={[
                            {
                                key: "rejected",
                                label: "Rejected items",
                                children: (
                                    <>

                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                flexWrap: "wrap",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            {/* LEFT SIDE - TITLE */}
                                            <Typography
                                                style={{
                                                    ...STYLES.tableTitle,
                                                    margin: 0,
                                                }}
                                            >
                                                Rejected Items
                                            </Typography>

                                            {/* RIGHT SIDE - ACTIONS */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                }}
                                            >
                                                <Button
                                                    type="primary"
                                                    style={{ height: "36px" }}
                                                    onClick={removeRejectsFun}
                                                >
                                                    Remove Selected
                                                </Button>

                                                 <div style={{ ...STYLES.searchBard }}>
                                                               <input
                                                                 className="searc_input"
                                                                 value={rejectIput}
                                                                 onChange={(e) => setRejectInput(e.target.value)}
                                                               />
                                                               <SearchOutlined
                                                                 className="search_btn"
                                                                 style={{
                                                                   color: "#737373",
                                                                   fontSize: "18px",
                                                                   padding: "10px",
                                                                   borderRadius: "6px",
                                                                 }}
                                                               />
                                                             </div>
                                            </div>
                                        </div>

                                        <Table
                                            rowKey="key"
                                            columns={REJECTED_COLUMNS_HEAD}
                                            dataSource={rejectedList}
                                            pagination={{
                                                pageSize: 4,
                                                responsive: true,
                                                hideOnSinglePage: true,
                                            }}
                                            rowSelection={{
                                                type: "checkbox",
                                                selectedRowKeys: rejectedSelectedRowsArray,
                                                onChange: (selectedRowKeys, selectedRows) => {
                                                    setRejectedSelectedRowsArray(selectedRowKeys);
                                                    const arr = selectedRows.map((ele) => {
                                                        return ele.spec_concat;
                                                    });
                                                    setRMoveList(arr);
                                                },
                                            }}
                                            style={{ marginTop: "20px" }}
                                            className="antdTable"
                                            locale={{
                                                emptyText: <TableEmptyContent />,
                                            }}
                                        />
                                    </>
                                ),
                            },
                            {
                                key: "completed",
                                label: "Escalation completed items",
                                children: (
                                    <>
                                        {/* <Typography style={{ ...STYLES.tableTitle }}>
                                            Escalation Completed Items
                                        </Typography> */}
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                flexWrap: "wrap",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            {/* LEFT SIDE - TITLE */}
                                            <Typography
                                                style={{
                                                    ...STYLES.tableTitle,
                                                    margin: 0,
                                                }}
                                            >
                                                Escalation Completed Items
                                            </Typography>

                                            {/* RIGHT SIDE - ACTIONS */}
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                }}
                                            >
                                                <Button
                                                    type="primary"
                                                    style={{ height: "36px" }}
                                                    onClick={removeCompletedFun}
                                                >
                                                    Remove Selected
                                                </Button>

                                                <div style={{ ...STYLES.searchBard }}>
                                                               <input
                                                                 className="searc_input"
                                                                 value={completeIput}
                                                                 onChange={(e) => setCompleteIput(e.target.value)}
                                                               />
                                                               <SearchOutlined
                                                                 className="search_btn"
                                                                 style={{
                                                                   color: "#737373",
                                                                   fontSize: "18px",
                                                                   padding: "10px",
                                                                   borderRadius: "6px",
                                                                 }}
                                                               />
                                                             </div>
                                            </div>
                                        </div>

                                        <Table
                                            rowKey="key"
                                            columns={getCompletedColumns(handleCompletedView)}
                                            dataSource={completedList}
                                            pagination={{
                                                pageSize: 4,
                                                responsive: true,
                                                hideOnSinglePage: true,
                                            }}
                                            rowSelection={{
                                                type: "checkbox",
                                                selectedRowKeys: completedSelectedRowsArray,
                                                onChange: (selectedRowKeys, selectedRows) => {
                                                    setCompletedSelectedRowsArray(selectedRowKeys);
                                                    const arr = selectedRows.map((ele) => ele.spec_concat);
                                                    setCMoveList(arr);
                                                },
                                            }}
                                            style={{ marginTop: "8px" }}
                                            className="antdTable"
                                            locale={{
                                                emptyText: <TableEmptyContent />,
                                            }}
                                        />
                                    </>
                                ),
                            },
                        ]}
                    />
                </div>
            </Spin>

            <ClosedLoopFeedbackModal
                open={isFeedbackModalOpen}
                onClose={() => {
                    setIsFeedbackModalOpen(false);
                    setSelectedCompletedRecord(null);
                }}
                record={selectedCompletedRecord}
                onRemove={handleClosedLoopRemoved}
            />

            {contextHolder}
        </div>
    );
}
